
export function loadStateFromStorage() {
    const saved = localStorage.getItem('fixfiber-building');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        return data;
      } catch (e) {
        console.error('Failed to load building:', e);
        return undefined;
      }
    } else {
      return undefined;
    }
}

export function saveStateToStorage(state) {
    localStorage.setItem('fixfiber-building', JSON.stringify(state));
}